import type { FeedbackValue } from "../../types";
import { FeedbackValueValues } from "../../types";
import styles from "./FeedbackValueBadge.module.css";

export interface FeedbackValueBadgeProps {
  value: FeedbackValue | string;
}

const FEEDBACK_LABELS: Record<string, string> = {
  [FeedbackValueValues.thumbs_up]: "Thumbs up",
  [FeedbackValueValues.thumbs_down]: "Thumbs down",
};

function resolveBadgeValue(value: string): string {
  if (value === FeedbackValueValues.thumbs_up || value === FeedbackValueValues.thumbs_down) {
    return value;
  }

  return "unknown";
}

export function FeedbackValueBadge({ value }: FeedbackValueBadgeProps) {
  const badgeValue = resolveBadgeValue(value);
  const label = FEEDBACK_LABELS[value] ?? value;

  return (
    <span className={styles.badge} data-value={badgeValue}>
      {label}
    </span>
  );
}
